exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub_t[data-v-358cde91]{font-size:.18rem;font-weight:bold}.page-btns[data-v-358cde91]{margin-top:.4rem;text-align:center}", ""]);

// exports
